<template>
    <div class="page-content">
        <div class="page-tool-bar">
            <div class="el-btn-group">
                <el-button type="danger" size="small" icon="el-icon-delete" @click="deleteFromType">清空</el-button>
            </div>
            <div class="icon-group">
                <span title="搜索" class="icon-box" @click="search">
                    <Icon color="#606266">
                        <Search />
                    </Icon>
                </span>
                <span class="icon-box">
                    <Icon color="#606266" @click="refreshLogList">
                        <Refresh />
                    </Icon>
                </span>
            </div>
        </div>
        <el-table
            :data="logList"
            element-loading-background="rgba(245, 245, 245, 0.3)"
            size="small"
            @selection-change="handleSelectionChange"
            height="100%"
        >
            <el-table-column align="center" prop="logTitle" label="日志类型" min-width="120"> </el-table-column>
            <el-table-column align="center" prop="userName" label="所属账号" min-width="160"> 
                <template slot-scope="scope">
                    <div v-if="scope.row.user">
                        <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                        <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                        <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                        <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
                    </div>
                    <div v-else>--</div>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="ipAddress" label="ip地址" min-width="100"> </el-table-column>
            <el-table-column align="center" prop="requestUri" label="URL" min-width="200"> </el-table-column>
            <el-table-column align="center" prop="params" label="请求参数" min-width="200"> </el-table-column>

            <el-table-column align="center" prop="method" label="请求方式" min-width="100"> </el-table-column>

            <el-table-column align="center" prop="createTime" label="访问时间" min-width="150"> </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" width="200">
                <template slot-scope="scop">
                    <div class="operation">
                        <div @click="checkLog(scop.row.logId)">
                            <Icon size="16">
                                <Eye24Regular />
                            </Icon>
                            <span>查看</span>
                        </div>
                        <div @click="deleteLog(scop.row.logId)">
                            <Icon size="16" style="color: red">
                                <Delete24Regular />
                            </Icon>
                            <span style="color: red">删除</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-box">
            <el-pagination
                @size-change="sizeChange"
                @current-change="currentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                background
                :pager-count="7"
            >
            </el-pagination>
        </div>
        <!-- 新增/查看/修改 -->
        <el-dialog :title="logStates[logState]" :visible.sync="showDialog" width="60%" @close="closeDialog">
            <div>
                <el-form :model="mppLog" ref="userForm" label-width="80px" :inline="true" size="mini">
                    <el-form-item label="日志类型" prop="logType">
                        <el-select
                            style="width: 200px"
                            :disabled="logState == 'check'"
                            placeholder="日志类型"
                            v-model="mppLog.logType"
                            size="small"
                        >
                            <el-option label="登录" :value="1"> </el-option>
                            <el-option label="获取列表" :value="2"> </el-option>
                            <el-option label="获取详情" :value="3"> </el-option>
                            <el-option label="新增" :value="4"> </el-option>
                            <el-option label="更新" :value="5"> </el-option>
                            <el-option label="删除" :value="6"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="ip地址">
                        <el-input
                            style="width: 200px"
                            :disabled="logState == 'check'"
                            placeholder="ip地址"
                            :rows="2"
                            v-model="mppLog.ipAddress"
                            size="small"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="URI">
                        <el-input
                            style="width: 200px"
                            :disabled="logState == 'check'"
                            type="textarea"
                            placeholder="URI"
                            :rows="3"
                            v-model="mppLog.requestUri"
                            size="small"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="请求参数">
                        <el-input
                            style="width: 200px"
                            :disabled="logState == 'check'"
                            type="textarea"
                            placeholder="请求参数"
                            :rows="3"
                            v-model="mppLog.params"
                            size="small"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="请求方式">
                        <el-input
                            style="width: 200px"
                            :disabled="logState == 'check'"
                            placeholder="请求方式"
                            :rows="2"
                            v-model="mppLog.method"
                            size="small"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="访问功能">
                        <el-input
                            style="width: 200px"
                            :disabled="logState == 'check'"
                            placeholder="访问功能"
                            :rows="2"
                            v-model="mppLog.logTitle"
                            size="small"
                        ></el-input>
                    </el-form-item>

                    <el-form-item label="访问时间">
                        <el-input
                            style="width: 200px"
                            :disabled="logState == 'check'"
                            placeholder="访问时间"
                            :rows="2"
                            v-model="mppLog.createTime"
                            size="small"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="flex justify-end">
                <el-button @click="closeDialog">关闭</el-button>
                <el-button type="primary" @click="submitForm" v-if="logState != 'check'">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { ArrowDownload24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, Search } from '@v2icons/tabler';
import { get, deleteFun } from '@/utils/request.js';
export default {
    name: 'DictTypeListTable',
    components: {
        GridDots,
        Refresh,
        Printer,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        ArrowDownload24Regular,
        Search
    },
    props: {
        index: String,
        logObject: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            loading: false,
            showDialog: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 10,
            currentDictId: '',
            logState: 'add',
            logStates: {
                check: '查看日志'
            },
            multipleSelection: [],
            logList: [],
            isSearch: false,
            checkMenu: {
                checkIndex: ''
            },
            mppLog: {
                logId: '',
                logType: '',
                logTitle: '',
                ipAddress: '',
                requestUri: '',
                method: '',
                params: '',
                logException: '',
                createTime: ''
            }
        };
    },
    created() {
        this.getLogList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
            this.$emit('send', this.isSearch);
        },
        init() {
            this.getLogList();
        },
        firstFun() {
            this.getLogList(this.logObject);
        },

        resetLogList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.logList = [];
        },
        resetDialog() {
            this.$refs.userForm.resetFields();
            this.userState = 'add';
            this.showDialog = false;
            this.dict = {};
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.logState == 'add') {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        addDict({ ...this.dict }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: '新增字典成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetLogList();
                                this.resetDialog();
                                this.getLogList();
                            }
                        });
                    }
                });
            } else if (this.logState == 'edit') {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        editDict({ ...this.dict }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: '编辑字典成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetLogList();
                                this.resetDialog();
                                this.getLogList();
                            }
                        });
                    }
                });
            }
        },
        addDict() {
            this.showDialog = true;
            this.logState = 'add';
        },
        checkLog(logId) {
            console.log(logId);
            this.getLogById(logId);
            this.showDialog = true;
            this.logState = 'check';
        },
        deleteFromType() {
            console.log('this.index', this.index);
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/log/deleteAllMppLogFromType`, { logType: this.index }).then((res) => {
                        console.log({ res });
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                        }
                        this.resetLogList();
                        this.getLogList();
                    });
                })
                .catch(() => {});
        },

        getLogById(logId) {
            get(`/mpp/log/get`, { logId: logId }).then((res) => {
                if (res.success) {
                    this.mppLog = { ...this.mppLog, ...res.mppLog };
                }
            });
        },
        deleteLog(logId) {
            let ids = '';
            if (logId) {
                ids = logId;
            } else {
                ids = this.multipleSelection.map((mppLog) => mppLog.logId).join(',');
            }

            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/log/delete`, { ids }).then((res) => {
                        console.log({ res });
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                        }
                        this.resetLogList();
                        this.getLogList();
                    });
                })
                .catch(() => {});
        },
        refreshLogList() {
            this.resetLogList();
            this.getLogList();
        },
        getLogList(query = {}) {
            this.loading = true;
            this.mppLog.logType = this.index;
            get(`/mpp/log/findList`, { ...this.logObject, logType: this.logObject.logType, pageNum: this.currentPage, pageSize: this.pageSize }).then(
                (res) => {
                    this.loading = false;
                    if (res.success) {
                        this.logList = res.logList.list;
                        this.totalNum = res.logList.total;
                    }
                }
            );
        },

        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getLogList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getLogList();
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
